export const getInitialCharacterState = () => ({
  abilityScores: {
    strength: null,
    dexterity: null,
    constitution: null,
    intelligence: null,
    wisdom: null,
    charisma: null,
  },
  asiChoices: {},
  background: "",
  backgroundSkills: [],
  castingStyle: "",
  gameSession: "",
  hitPoints: 0,
  house: "",
  houseChoices: {},
  initiativeAbility: "dexterity",
  innateHeritage: "",
  innateHeritageSkills: [],
  level: 1,
  level1ChoiceType: "",
  magicModifiers: {
    divinations: 0,
    charms: 0,
    transfiguration: 0,
    healing: 0,
    jinxesHexesCurses: 0,
  },
  name: "",
  schoolYear: null,
  skillProficiencies: [],
  standardFeats: [],
  subclass: "",
  wandType: "",
});
